import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class newsletterTemplateView_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return (`

            <div class="w-form w-form-large">
                
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button> 
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <div class="w-btn">
                         <button data-bind="event: { click: onClickEditNewsletterTemplate }, visible: permissions()['newsletter_templates'].read" class="btn icon i-edit"  type="button">Edit Newsletter Template</button>
                    </div>
                </div>
                
                
                <div class="w-form-body">
                   
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Title</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: name"></span>
                                </dd>
                                <dt>
                                    <span>Sender Email Name</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: senderName"></span>
                                </dd>
                                <dt>
                                    <span>Sender Email Address</span>
                                </dt>
                                <dd>
                                    <span style="text-transform: lowercase;" data-bind="text: sender"></span>
                                </dd>
                                <dt>
                                    <span>UTM Source</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: utmSource"></span>
                                </dd>

                                <dt>
                                    <span>Available for Use on Emails</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isEmails"></span>
                                </dd>
                                <dt>
                                    <span>Available for Use on Interaction Emails</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isInteractionEmails"></span>
                                </dd>                        
                                <dt>
                                    <span>Available for Use on Login System Emails</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isLoginSystemEmails"></span>
                                </dd>                        
                                
                             </dl>
                         </div>
                    </div>
                    
                    <div class="form-body">
                        <div class="form-group">
                            <label for="">Header Preview</label>
                            <div class="preview-header" data-bind="style:{'background-color': color()}, css: { 'full-width': isBannerImageFullWidth }">
                                <img data-bind="attr: {src: logoUrl()}">
                            </div>
                        </div>
                        <div class="form-group">
                            <dl class="double-list">
                                <dt>
                                    <span>Header Background Color</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: colorName"></span>
                                </dd>                            
                                <dt>
                                    <span>Header Image</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: logoName"></span>
                                </dd>
                                <dt>
                                    <span>Header Image Occupies Full Width</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isBannerImageFullWidth"></span>
                                </dd>
                                <dt>
                                    <span>Include Send Date Under Header</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: includeSendDateUnderHeader"></span>
                                </dd>                                
                                <dt>
                                    <span>Content Text Primary Color</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: primaryColor"></span>
                                </dd>
                                <dt>
                                    <span>Content Text Secondary Color</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: secondaryColor"></span>
                                </dd>
                                <dt>
                                    <span>Sidebar Background Color</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: sidebarBackgroundColor"></span>
                                </dd>

                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        `);
    }

    protected buildViewModel(): any {

        let self = this
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            senderName: ko.observable(""),
            sender: ko.observable(""),
            utmSource: ko.observable(""),
            color: ko.observable(""),
            colorName: ko.observable(""),
            logoName: ko.observable(""),
            logoUrl: ko.observable(""),
            primaryColor: ko.observable(""),
            secondaryColor: ko.observable(""),
            sidebarBackgroundColor: ko.observable(""),
            isEmails: ko.observable(""),
            isInteractionEmails: ko.observable(""),
            isLoginSystemEmails: ko.observable(""),
            isBannerImageFullWidth: ko.observable(""),
            includeSendDateUnderHeader: ko.observable(""),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            permissions: ko.observableArray(this.initPermissions([ 'newsletter_templates'])),
            onClickEditNewsletterTemplate: function (data, event) {
                self.onClickEditNewsletterTemplate(data.id());
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
        }
    }

    protected getTemplateName(): string {

        return "newsletterTemplateView_template";
    }

    protected onClickEditNewsletterTemplate(id: any): any {

        this.caller.onClickEditNewsletterTemplate(id)
    }

    protected onClickCancel(): any {

        this.caller.onClickCancel()
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
    }

    protected setNewsletterTemplateData(template) {

        this.getTemplateViewModel().id(template.id);
        this.getTemplateViewModel().name(template.name);
        this.getTemplateViewModel().senderName(template.senderName);
        this.getTemplateViewModel().sender(template.sender.name);
        this.getTemplateViewModel().utmSource(template.utmSource);
        this.getTemplateViewModel().colorName(template.headerColor ? template.headerColor.name : "None");
        this.getTemplateViewModel().color(template.headerColor ? template.headerColor.value : "");
        this.getTemplateViewModel().logoName(template.headerLogo.name);
        this.getTemplateViewModel().logoUrl(template.headerLogo.value);
        this.getTemplateViewModel().primaryColor(template.primaryColor.name);
        this.getTemplateViewModel().secondaryColor(template.secondaryColor.name);
        this.getTemplateViewModel().sidebarBackgroundColor(template.sidebarBackgroundColor ? template.sidebarBackgroundColor.name : "None");
        this.getTemplateViewModel().isEmails(template.isEmails ? "True" : "False");
        this.getTemplateViewModel().isInteractionEmails(template.isInteractionEmails ? "True" : "False");
        this.getTemplateViewModel().isLoginSystemEmails(template.isLoginSystemEmails ? "True" : "False");
        this.getTemplateViewModel().dateCreated(template.dateCreated);
        this.getTemplateViewModel().dateUpdated(template.dateUpdated);
        this.getTemplateViewModel().isBannerImageFullWidth(!!template.isBannerImageFullWidth);

        // templates created before this option existed have no stored value and default to enabled
        let includeSendDateUnderHeader = template.includeSendDateUnderHeader;
        let isSendDateIncluded = (includeSendDateUnderHeader === null || includeSendDateUnderHeader === undefined) ? true : !!includeSendDateUnderHeader;
        this.getTemplateViewModel().includeSendDateUnderHeader(isSendDateIncluded ? "True" : "False");
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/newsletterTemplateView_template.ts